import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (path) =>
  /^https?:\/\//.test(path) ? path : `${API}/files/${path}`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("erskine_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("erskine_token");
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const track = (page, vehicleId = null) =>
  api.post("/track", { page, vehicle_id: vehicleId }).catch(() => {});

export const PHONE_DISPLAY = "(506) 469-5597";
export const PHONE_TEL = "+15064695597";
export const ADDRESS = "249 Route 170, Oak Bay, N.B.";
export const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=249+Route+170+Oak+Bay+New+Brunswick";
